function setBanners(state, banners) {
  state.banners = banners
}

function setBannerDetails(state, bannerDetails) {
  state.bannerDetails = bannerDetails
}

function setSearchTerm(state, value) {
  state.searchTerm = value
}

function setEditableBannerFields(state, bannerDetails) {
  state.editableBannerFields = {
    id: bannerDetails.id,
    name: bannerDetails.name,
    companiesId: bannerDetails.companiesId,
  }
}

function setBannerListLoading(state, loading) {
  state.isBannerLoading = loading
}

function createBannerDetails(state) {
  state.bannerDetails = {
    name: null,
    companiesId: null,
    company: null,
  }
  state.editableBannerFields = {
    name: null,
    companiesId: null,
  }
}

export default{
  setBanners,
  setBannerDetails,
  setSearchTerm,
  setEditableBannerFields,
  setBannerListLoading,
  createBannerDetails,
}



// WEBPACK FOOTER //
// ./src/store/modules/banner/banner.mutations.js